export enum ChematCustomerType {
  RETAIL = 1,
  COMPANY = 2,
  SCHOOL = 3,
  SCHOOL_PERSON = 4,
}
